import {useState, useCallback} from 'react'

import {TabTypeDto} from '../types'

const ALL_TABS_FILTER = 'all' as const
type TabFilterValue = TabTypeDto | typeof ALL_TABS_FILTER

export type EditKpisModalState = {
  isEditKpisModalOpen: boolean
  openEditKpisModal: () => void
  closeEditKpisModal: () => void
  editModalTabFilter: TabFilterValue
  setEditModalTabFilter: (value: TabFilterValue) => void
  editModalSearchTerm: string
  setEditModalSearchTerm: (value: string) => void
  resetEditModalFilters: () => void
}

/**
 * Hook to manage Edit KPIs modal state
 * - Modal open/close state
 * - Tab type filter (to filter displayed groups/KPIs)
 * - Search term (to filter by KPI/group name)
 */
export const useEditKpisModalState = (): EditKpisModalState => {
  const [isEditKpisModalOpen, setIsEditKpisModalOpen] = useState(false)
  const [editModalTabFilter, setEditModalTabFilter] = useState<TabFilterValue>(ALL_TABS_FILTER)
  const [editModalSearchTerm, setEditModalSearchTerm] = useState('')

  const openEditKpisModal = useCallback(() => {
    setIsEditKpisModalOpen(true)
  }, [])

  const closeEditKpisModal = useCallback(() => {
    setIsEditKpisModalOpen(false)
    // Reset filters when closing modal
    setEditModalTabFilter(ALL_TABS_FILTER)
    setEditModalSearchTerm('')
  }, [])

  const resetEditModalFilters = useCallback(() => {
    setEditModalTabFilter(ALL_TABS_FILTER)
    setEditModalSearchTerm('')
  }, [])

  return {
    isEditKpisModalOpen,
    openEditKpisModal,
    closeEditKpisModal,
    editModalTabFilter,
    setEditModalTabFilter,
    editModalSearchTerm,
    setEditModalSearchTerm,
    resetEditModalFilters
  }
}

export {ALL_TABS_FILTER}
export type {TabFilterValue}
